'use client';

import dynamic from 'next/dynamic';
import Link from 'next/link';

import type { User } from '@supabase/supabase-js';

//import { ArrowRightIcon } from 'lucide-react';

import { PersonalAccountDropdown } from '@kit/accounts/personal-account-dropdown';
import { useSignOut } from '@kit/supabase/hooks/use-sign-out';
import { useUser } from '@kit/supabase/hooks/use-user';
import { Button } from '@kit/ui/button';
//import { If } from '@kit/ui/if';
import { Trans } from '@kit/ui/trans';

import featuresFlagConfig from '~/config/feature-flags.config';
import pathsConfig from '~/config/paths.config';

const ModeToggle = dynamic(() =>
  import('@kit/ui/mode-toggle').then((mod) => ({
    default: mod.ModeToggle,
  })),
);

const paths = {
  home: pathsConfig.app.home,
  settings: pathsConfig.app.personalAccountSettings,
  billing: pathsConfig.app.personalAccountBilling,
  support: pathsConfig.app.support,
};

const features = {
  enableThemeToggle: featuresFlagConfig.enableThemeToggle,
};

export function SiteHeaderAccountSection({
  user,
}: React.PropsWithChildren<{
  user: User | null;
}>) {
  if (!user) {
    return <AuthButtons />;
  }

  return <SuspendedPersonalAccountDropdown user={user} />;
}

function SuspendedPersonalAccountDropdown(props: { user: User | null }) {
  const signOut = useSignOut();
  const user = useUser(props.user);
  const userData = user.data ?? props.user ?? null;

  if (userData) {
    return (
      <PersonalAccountDropdown
        showProfileName={false}
        paths={paths}
        features={features}
        user={userData}
        signOutRequested={() => signOut.mutateAsync()}
      />
    );
  }

  return <AuthButtons />;
}

function AuthButtons() {
  return (
    <div className={'hidden items-center space-x-1 lg:flex xl:space-x-6'}>
      <div className={'flex space-x-0.5'}>
        {/* <If condition={features.enableThemeToggle}>
          <ModeToggle />
        </If> */}

        <Button
          asChild
          variant={'ghost'}
          size={'sm'}
          className="px-4 text-gray-500 xl:text-lg"
        >
          <Link href={pathsConfig.auth.signIn}>
            <Trans i18nKey={'auth:signIn'} />
          </Link>
        </Button>
      </div>

      {/* <Button
        asChild
        className="group px-4 drop-shadow-none xl:text-lg 2xl:px-10 2xl:py-5"
        variant={'default'}
        size={'lg'}
      >
        <Link href={pathsConfig.auth.signUp}>
          <Trans i18nKey={'auth:signUp'} />
        </Link>
      </Button> */}

      <Button
        asChild
        className="group hidden px-4 text-sm drop-shadow-none lg:flex xl:text-lg 2xl:px-10 2xl:py-5"
        variant={'default'}
        size={'lg'}
      >
        <Link href={pathsConfig.auth.signUp}>
          <span className="hidden xl:block">
            <Trans i18nKey={'common:getStarted'} />
          </span>
          <span className="block xl:hidden">
            <Trans i18nKey={'common:getStartedShort'} />
          </span>
        </Link>
      </Button>
    </div>
  );
}
